import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationApiService } from '@xpo-ltl-2.0/sdk-location';
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { DataApiService } from '@xpo-ltl/data-api';
import { UserProfileComponent, xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { SdkShippingToolsModule } from '@xpo-ltl/sdk-shippingtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ColumnKeyRendererComponent } from './tariff-list/components/column-key-renderer/column-key-renderer.component';
import { XpoAgGridModule } from '@xpo-ltl/ngx-ag-grid';
import { XpoErrorPagesModule } from '@xpo-ltl/ngx-ltl-core/error-pages';

export const appAuthConfig = () => {
  return xpoConfigManagerProvider(
    xpoAuthConfigManagerConfiguration({
      firebaseOptions: environment.firebase,
    })
  );
};

@NgModule({
  declarations: [AppComponent, ColumnKeyRendererComponent],
  imports: [
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    XpoIconModule,
    XpoButtonModule,
    XpoCardModule,
    XpoAgGridModule,
    XpoDialogModule,
    XpoShellModule,
    MatMenuModule,
    XpoSnackBarModule,
    XpoErrorPagesModule,
    SdkShippingToolsModule,
    AppRoutingModule,
    XpoFooterModule,
    XpoConfirmDialogModule,
    UserProfileComponent,
  ],
  providers: [appAuthConfig(), DataApiService, LocationApiService, DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
